import * as React from "react";
import { useCallback, useEffect, useMemo } from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Modal } from "components/bootstrap";
import { Wizard as CommonWizard } from "components/common";
import { INPUT_WIZARD_STEPS, INPUT_WIZARD_FLOWS } from "components/inputs/InputSetupWizard/types";
import { OPEN_FLOW_STEPS } from "components/inputs/InputSetupWizard/constants";
import useInputSetupWizard from "components/inputs/InputSetupWizard/hooks/useInputSetupWizard";
import InputSetupWizardStepsProvider from "./contexts/InputSetupWizardStepsProvider";
import { InputDiagnosisStep, SetupRoutingStep, StartInputStep } from "./steps";
const Wizard = ({ show, input, onClose }) => {
  var _a;
  const { activeStep, setActiveStep, orderedSteps, setOrderedSteps, setWizardData, wizardData } = useInputSetupWizard();
  const EnterpriseWizard = (_a = PluginStore.exports("inputSetupWizard").find(
    (plugin) => !!plugin.EnterpriseInputSetupWizard
  )) == null ? void 0 : _a.EnterpriseInputSetupWizard;
  useEffect(() => {
    setWizardData({ ...wizardData, input });
  }, []);
  const steps = useMemo(
    () => ({
      [INPUT_WIZARD_STEPS.SETUP_ROUTING]: {
        key: INPUT_WIZARD_STEPS.SETUP_ROUTING,
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Routing"),
        component: /* @__PURE__ */ React.createElement(SetupRoutingStep, null),
        disabled: true
      },
      [INPUT_WIZARD_STEPS.START_INPUT]: {
        key: INPUT_WIZARD_STEPS.START_INPUT,
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Launch"),
        component: /* @__PURE__ */ React.createElement(StartInputStep, null),
        disabled: true
      },
      [INPUT_WIZARD_STEPS.INPUT_DIAGNOSIS]: {
        key: INPUT_WIZARD_STEPS.INPUT_DIAGNOSIS,
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, "Diagnosis"),
        component: /* @__PURE__ */ React.createElement(InputDiagnosisStep, { onClose: () => onClose() }),
        disabled: true
      }
    }),
    [onClose]
  );
  const setInitialSteps = useCallback(() => {
    setOrderedSteps(OPEN_FLOW_STEPS[INPUT_WIZARD_FLOWS.NON_ILLUMINATE]);
    setActiveStep(OPEN_FLOW_STEPS[INPUT_WIZARD_FLOWS.NON_ILLUMINATE][0]);
  }, [setOrderedSteps, setActiveStep]);
  useEffect(() => {
    if (EnterpriseWizard) return;
    if (!activeStep) {
      setInitialSteps();
    }
  }, [EnterpriseWizard, activeStep, setInitialSteps]);
  if (!show) return null;
  const orderedStepsConfig = orderedSteps.map((step) => steps[step]);
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, "Input Setup Wizard"), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(InputSetupWizardStepsProvider, null, EnterpriseWizard ? /* @__PURE__ */ React.createElement(EnterpriseWizard, { openSteps: steps }) : orderedSteps.length > 0 && /* @__PURE__ */ React.createElement(
    CommonWizard,
    {
      activeStep,
      hidePreviousNextButtons: true,
      horizontal: true,
      justified: true,
      onStepChange: setActiveStep,
      steps: orderedStepsConfig
    }
  ))));
};
export default Wizard;
